module.exports = __webpack_public_path__ + "static/img/turntable.18b65aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/turntable.png
// module id = fvNt
// module chunks = 1